import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
  '2xs': {
    value: {
      fontSize: '2xs',
      lineHeight: '0.75rem',
    },
  },
  xs: {
    value: {
      fontSize: 'xs',
      lineHeight: '1rem',
    },
  },
  sm: {
    value: {
      fontSize: 'sm',
      lineHeight: '1.25rem',
    },
  },
  md: {
    value: {
      fontSize: 'md',
      lineHeight: '1.5rem',
    },
  },
  lg: {
    value: {
      fontSize: 'lg',
      lineHeight: '1.75rem',
    },
  },
  xl: {
    value: {
      fontSize: 'xl',
      lineHeight: '1.875rem',
    },
  },
  '2xl': {
    value: {
      fontSize: '2xl',
      lineHeight: '2rem',
    },
  },
  '3xl': {
    value: {
      fontSize: '3xl',
      lineHeight: '2.375rem',
    },
  },
  '4xl': {
    value: {
      fontSize: '4xl',
      lineHeight: '2.75rem',
      letterSpacing: '-0.025em',
    },
  },
  '5xl': {
    value: {
      fontSize: '5xl',
      lineHeight: '3.75rem',
      letterSpacing: '-0.025em',
    },
  },
  '6xl': {
    value: {
      fontSize: '6xl',
      lineHeight: '4.5rem',
      letterSpacing: '-0.025em',
    },
  },
  '7xl': {
    value: {
      fontSize: '7xl',
      lineHeight: '5.75rem',
      letterSpacing: '-0.025em',
    },
  },
  none: {
    value: {},
  },

  // ── Semantic text styles (typography only, no color) ────────────────
  // Color via fg.* semantic tokens: <Text textStyle="title" color="fg.muted">
  //
  // heading  — xl/700  — page titles
  // subtitle — xl/600  — dialog headers, drawer headers, section titles
  // section  — md/600  — card and section titles (settings cards, panels)
  // nav      — md/500  — sidebar nav, tab labels
  // strong   — sm/700  — emphasis inside text, numbers on game stat cards
  // title    — sm/600  — section headings, game names, labels, dates
  // body     — sm/400  — descriptions, comments, meta text
  // label    — xs/600  — compact labels and chips
  // caption  — xs/500  — small meta (duration, members, time)
  // badge    — xs/700  — status badges (LIVE, Upcoming, counters)
  // micro    — 2xs/700 — tiny badges, tab counters

  heading: {
    value: {
      fontSize: 'xl',
      lineHeight: '1.875rem',
      fontWeight: '700',
    },
  },
  subtitle: {
    value: {
      fontSize: 'xl',
      lineHeight: '1.875rem',
      fontWeight: '600',
    },
  },
  section: {
    value: {
      fontSize: 'md',
      lineHeight: '1.5rem',
      fontWeight: '600',
    },
  },
  nav: {
    value: {
      fontSize: 'md',
      lineHeight: '1.5rem',
      fontWeight: '500',
    },
  },
  strong: {
    value: {
      fontSize: 'sm',
      lineHeight: '1.25rem',
      fontWeight: '700',
    },
  },
  title: {
    value: {
      fontSize: 'sm',
      lineHeight: '1.25rem',
      fontWeight: '600',
    },
  },
  body: {
    value: {
      fontSize: 'sm',
      lineHeight: '1.25rem',
      fontWeight: '400',
    },
  },
  label: {
    value: {
      fontSize: 'xs',
      lineHeight: '1rem',
      fontWeight: '600',
    },
  },
  caption: {
    value: {
      fontSize: 'xs',
      lineHeight: '1rem',
      fontWeight: '500',
    },
  },
  badge: {
    value: {
      fontSize: 'xs',
      lineHeight: '1rem',
      fontWeight: '700',
    },
  },
  micro: {
    value: {
      fontSize: '2xs',
      lineHeight: '0.75rem',
      fontWeight: '700',
    },
  },
});
